export default {
      id: "sli-bell-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.9328ef59.svg#sli-bell",
      toString: function () {
        return this.url;
      }
    }